import { range } from 'lodash';
import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledParagraphLine, StyledTitle } from './paragraph-placeholder.styled';

interface OwnProps {
  numberOfRows: number;
  hasTitle?: boolean;
}

export type ParagraphPlaceholderProps = OwnProps;

export const ParagraphPlaceholder: FunctionComponent<ParagraphPlaceholderProps> = (props) => {
  const { numberOfRows, hasTitle, ...rest } = props;

  return (
    <StyledContainer {...rest}>
      {hasTitle && <StyledTitle />}
      {range(numberOfRows).map((index) => (
        <StyledParagraphLine key={index} />
      ))}
    </StyledContainer>
  );
};
